//============================
//# enum from backend "PaymentDateCountTypeEntity" but table exist at mmgenpayday_type
//============================ 

export default interface PayCountType {
    id: number;
    name: string;
}

export const PayCountTypeDefaultProps: PayCountType = {
    id: 1,
    name: "-"
}